const ShimmerLoader = () => (
    <div className="px-4 py-4 mt-3 mx-3 bg-white h-maintableheight2 rounded-lg flex flex-col animate-pulse">
        <div className="flex flex-wrap">
            {Array(5).fill(0).map((_, index) => (
                <div key={index} className="w-1/3 mb-8">
                    <div className="h-6 w-[30%] bg-gray-300 rounded-sm mb-2"></div>
                    <div className="h-8 w-[60%] bg-gray-200 rounded-sm"></div>
                </div>
            ))}
        </div>
        <div className="w-full mb-4">
            <div className="h-4 w-[20%] bg-gray-300 rounded-sm mb-2"></div>
            <div className="h-16 w-full bg-gray-200 rounded-sm"></div>
        </div>
    </div>
);
export default ShimmerLoader;